import React, { useRef, useState } from 'react';
import useReveal from '../hooks/useReveal';
import './CompanyVideo.css';
import { trackEvent } from '../analytics';

export default function CompanyVideo() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const ref = useReveal();

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
      trackEvent('video_play', { video: 'company_overview' });
    } else {
      v.pause();
      setPlaying(false);
      trackEvent('video_pause', { video: 'company_overview' });
    }
  };

  return (
    <section className="section companyvideo" id="story">
      <div className="container reveal" ref={ref}>
        <p className="eyebrow">Meet the company</p>
        <h2 className="section-heading">
          Two minutes on why we exist, what we've built, and where we're taking it.
        </h2>

        <div className={`companyvideo__player ${playing ? 'is-playing' : ''}`}>
          <video
            ref={videoRef}
            className="companyvideo__video"
            playsInline
            controls={playing}
            poster="/assets/images/pitch-poster.jpg"
            onPause={() => setPlaying(false)}
            onEnded={() => setPlaying(false)}
          >
            {/*
              Drop your company-explainer video here:
                public/videos/company-overview.mp4
            */}
            <source src="/videos/company-overview.mp4" type="video/mp4" />
          </video>

          {!playing && (
            <button className="companyvideo__play" onClick={toggle} aria-label="Play company overview video">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                <path d="M6 3.5L22 13L6 22.5V3.5Z" fill="currentColor" />
              </svg>
            </button>
          )}

          {!playing && <div className="companyvideo__scrim" />}
          {!playing && (
            <div className="companyvideo__caption">
              <strong>Inivayal Agritech — Company Overview</strong>
              <span>Founder walkthrough · Product demo · Vision</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
